import request from '@host-panel/request';
import { Folder, ContentType } from '../state/types';

type RequestPayload = {
  spotId: string;
  from?: number; // unixtimestamp for the last fetch
  folder: Folder;
  contentType?: ContentType;
  filters?: Record<string, string | boolean>;
};

type Response = {
  total_items: {
    [key in Folder]?: number;
  };
};

export default function count({
  spotId,
  from,
  folder,
  contentType = 'COMMENTS',
  filters = {}
}: RequestPayload): Promise<Response> {
  return request(`/host-panel/read/${contentType.toLowerCase()}/count`, {
    method: 'GET',
    data: {
      spot_id: spotId,
      folder_name: folder,
      written_at: from,
      ...filters
    }
  });
}
